module.exports = __webpack_public_path__ + "static/media/1001344MF.9e2a9885.jpg";